/* app/js/src/components/mam-explorer/mam-explorer-actions-cell/mam-explorer-actions-cell.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.mam-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 100%;
}
.mam-actions-cell__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  color: rgb(114, 125, 139);
  cursor: pointer;
  transition: all 0.15s;
}
.mam-actions-cell__btn:hover {
  background-color: rgb(233, 248, 255);
  color: rgb(45, 187, 252);
  border-color: rgba(45, 187, 252, 0.5);
}
/*# sourceMappingURL=mam-explorer-actions-cell.component.css.map */
